const Autos = [
  {
    name: "Auto 1",
    phone: "8686858502",
    capacity: 6,
    em_fac: 350,
  },
  {
    name: "Auto 2",
    phone: "9553375890",
    capacity: 6,
    em_fac: 350,
  },
  // {
  //   name: "Auto 3",
  //   phone: "9876543210",
  //   capacity: 6,
  //   em_fac: 350,
  // },
];

export default Autos;
